import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import partnerService from 'services/partnerService';
import { closeModal, openModal } from 'reducers/modalReducer';
import PrivateIndividual from 'types/PrivateIndividual';
import { isNotNullOrUndefined } from 'utils/utils';

export const useFetchLegalPartner = (techId: string, enabled = true) => {
  const dispatch = useDispatch();
  const title = 'Error fetching partner data';
  const userErrorMessage = 'An error occurred when fetching legal entity partner data';

  const onCloseErrorClick = () => {
    dispatch(closeModal('JBErrorModalWrapper'));
  };

  const query = useQuery<any, AxiosError>({
    queryKey: [`fetchLegalPartner`, techId],
    queryFn: () => partnerService.getLegalPartner(techId),
    enabled,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error fetching legal-entity partner from partner-data-mgmt',
              title,
              userErrorMessage,
            },
            httpError: error,
            handleClose: onCloseErrorClick,
          },
        }),
      );
    }
  }, [isError, error, dispatch]);

  return query;
};

export const useFetchPrivateIndividualPartner = (techId: string, enabled = true) => {
  const dispatch = useDispatch();
  const title = 'Error fetching partner data';
  const userErrorMessage = 'An error occurred when fetching private individual partner data';

  const onCloseErrorClick = () => {
    dispatch(closeModal('JBErrorModalWrapper'));
  };

  const query = useQuery<PrivateIndividual, AxiosError>({
    queryKey: ['fetchPrivateIndividual', techId],
    queryFn: () => partnerService.getPartner(techId),
    enabled,
  });

  const { error, isError } = query;

  useEffect(() => {
    if (isError && isNotNullOrUndefined(error)) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            technicalInfo: {
              details: 'Error fetching private-individual partner from partner-data-mgmt',
              title,
              userErrorMessage,
            },
            httpError: error,
            handleClose: onCloseErrorClick,
          },
        }),
      );
    }
  }, [isError, error, dispatch, onCloseErrorClick]);

  return query;
};
